import blog from "./blog";
import store from "./store";

export default {
  store,
  blog,
};
